"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tshirt = void 0;
var tshirt = {
  "viewBox": "0 0 512 512",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M480,96L320,48c-13.988,27.227-30.771,40.223-63.769,40.223C223.723,87.676,205.722,75,192,48L32,96l32,88l64-8l-16,288h288\r\n\tl-16-288l64,8L480,96z"
    },
    "children": []
  }]
};
exports.tshirt = tshirt;